<!-- Loader before data arrives -->
<app-loader *ngIf="(profileState | async).audits._embedded === undefined" message="Loading your reports..."></app-loader>

<section class="profile-list-section" *ngIf="(profileState | async).audits._embedded !== undefined">
  <app-breadcrumbs type="profileReportsList"></app-breadcrumbs>

  <!-- Header -->
  <div class="profile-list-header">
    <div class="header-content">
      <h1 class="header-title">Your Reports</h1>
      <span class="header-subtitle" *ngIf="(userState | async).user !== null">
        <span class="credits-badge">
          <i class="bi bi-lightning-charge-fill"></i>
          {{(userState | async).user.permissions['auditor.limit']}} credits
        </span>
        <span class="followers-info" *ngIf="(userState | async).user.permissions['auditor.followers.max'] !== undefined">
          <span *ngIf="(userState | async).user.permissions['auditor.followers.max'] > 0">{{(userState | async).user.permissions['auditor.followers.max'] | shortcutNumbers}} max</span>
          <span *ngIf="(userState | async).user.permissions['auditor.followers.max'] <= 0">Unlimited</span>
        </span>
      </span>
    </div>
    <a routerLink="/audit/add" class="btn btn-blue btn-sm">
      <i class="bi bi-plus-lg"></i>
      Add Report
    </a>
  </div>

  <!-- Credit Alert -->
  <div class="credit-alert" *ngIf="(userState | async).user !== null && (userState | async).user.permissions['auditor.limit'] === 1">
    <div class="alert-icon">
      <i class="bi bi-lightbulb-fill"></i>
    </div>
    <div class="alert-content">
      <strong>You have 1 credit left!</strong>
      <p>Choose the report you'd like to upgrade to PRO</p>
    </div>
  </div>

  <!-- Loading State -->
  <app-loader *ngIf="!(profileState | async).loader['auditList']['list']" size="sm" message="Loading your reports..."></app-loader>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="(profileState | async).audits._embedded.items.length === 0 && (profileState | async).loader['auditList']['list']">
    <div class="empty-icon">
      <i class="bi bi-bar-chart-line"></i>
    </div>
    <h2>Start Your First Audit</h2>
    <p>Analyze any Instagram or TikTok profile to get detailed insights about their audience and engagement.</p>
    <a class="btn btn-blue btn-lg btn-animated" *ngIf="(userState | async).user.permissions['auditor.limit'] === 0" routerLink="/audit/add">
      <i class="bi bi-plus-lg"></i>
      Add profile to see trial report
    </a>
    <a class="btn btn-blue btn-lg btn-animated" *ngIf="(userState | async).user.permissions['auditor.limit'] > 0" routerLink="/audit/add">
      <i class="bi bi-plus-lg"></i>
      Add first profile audit
    </a>
    <p class="demo-hint">or check out our demo reports below</p>
  </div>

  <!-- Profile Cards List -->
  <div class="profile-cards-container" [class.loading]="!(profileState | async).loader['auditList']['list']" *ngIf="(profileState | async).audits._embedded.items.length !== 0">

    <!-- Table Header (desktop only) -->
    <div class="list-header">
      <span class="col-profile">Profile</span>
      <span class="col-stat">Followers</span>
      <span class="col-stat">Quality</span>
      <span class="col-stat">Engagement</span>
      <span class="col-status">Status</span>
      <span class="col-actions"></span>
    </div>

    <a class="profile-row"
       *ngFor="let profile of (profileState | async).audits._embedded.items"
       [routerLink]="['/audit', profile.id, profile.channel_type === 'tiktok' ? 'tiktok' : 'waiting']">

      <!-- Profile Info -->
      <div class="col-profile">
        <div class="profile-avatar">
          <ng-container *ngIf="profile.channel_type === 'instagram'">
            <img *ngIf="profile.instagram_user !== undefined" [src]="profile.instagram_user.profile_pic_url" onerror="this.onerror=null;this.src='./assets/images/icons/face.png'" alt=""/>
            <img *ngIf="profile.instagram_user === undefined" src="assets/images/icons/face.png" alt=""/>
            <span class="platform-icon instagram">
              <i class="bi bi-instagram"></i>
            </span>
          </ng-container>
          <ng-container *ngIf="profile.channel_type === 'tiktok'">
            <img *ngIf="profile.tiktok_user !== undefined" [src]="profile.tiktok_user.avatar" onerror="this.onerror=null;this.src='./assets/images/icons/face.png'" alt=""/>
            <img *ngIf="profile.tiktok_user === undefined" src="assets/images/icons/face.png" alt=""/>
            <span class="platform-icon tiktok">
              <i class="bi bi-tiktok"></i>
            </span>
          </ng-container>
        </div>
        <div class="profile-details">
          <span class="profile-name" [class.error]="profile.status === 3">
            &#64;{{profile.profile}}
            <i class="bi bi-exclamation-circle-fill" *ngIf="profile.status === 3"></i>
          </span>
          <span class="profile-date">{{profile.added_time * 1000 | date:'mediumDate'}}</span>
        </div>
      </div>

      <!-- Stats (inline) -->
      <div class="col-stat">
        <span class="stat-label-mobile">Followers</span>
        <span class="stat-value" *ngIf="profile.status === 2">{{profile.bio.follower_count | shortcutNumbers}}</span>
        <span class="stat-value muted" *ngIf="profile.status === 1">...</span>
        <span class="stat-locked" *ngIf="profile.status === 0 || profile.status === 10">
          <i class="bi bi-lock-fill"></i>
        </span>
      </div>

      <div class="col-stat">
        <span class="stat-label-mobile">Quality</span>
        <span class="stat-value" *ngIf="profile.status === 2">{{profile.bio.quality_followers | number:'1.1'}}%</span>
        <span class="stat-value muted" *ngIf="profile.status === 1">...</span>
        <span class="stat-locked" *ngIf="profile.status === 0 || profile.status === 10">
          <i class="bi bi-lock-fill"></i>
        </span>
      </div>

      <div class="col-stat">
        <span class="stat-label-mobile">Engage</span>
        <span class="stat-value" *ngIf="profile.status === 2">
          <span *ngIf="profile.bio.engagement">{{profile.bio.engagement | number:'1.2'}}%</span>
          <span *ngIf="!profile.bio.engagement">-</span>
        </span>
        <span class="stat-value muted" *ngIf="profile.status === 1">...</span>
        <span class="stat-locked" *ngIf="profile.status === 0 || profile.status === 10">
          <i class="bi bi-lock-fill"></i>
        </span>
      </div>

      <!-- Status -->
      <div class="col-status">
        <span class="status-badge available" *ngIf="profile.status === 2">
          <i class="bi bi-check-circle-fill"></i> Ready
        </span>
        <span class="status-badge pending" *ngIf="profile.status === 1 && profile.bio.progress !== 33">
          <i class="bi bi-hourglass-split"></i> {{profile.bio.progress}}%
        </span>
        <span class="status-badge trial" *ngIf="profile.status === 0 || profile.status === 10">
          <i class="bi bi-star-fill"></i> Trial
        </span>
        <span class="status-badge warning" *ngIf="profile.status === 1 && profile.bio.mention_count === 0">
          <i class="bi bi-exclamation-triangle-fill"></i> No posts
        </span>
        <span class="status-badge error" *ngIf="profile.status === 3">
          <i class="bi bi-x-circle-fill"></i> Error
        </span>
      </div>

      <!-- Actions -->
      <div class="col-actions" (click)="$event.stopPropagation(); $event.preventDefault()">
        <ng-container *ngIf="(profile.status === 0 || profile.status === 10) && (userState | async).user !== null">
          <a class="btn btn-blue btn-sm" routerLink="/payment/add" *ngIf="(userState | async).user.permissions['auditor.limit'] === 0">
            Buy PRO
          </a>
          <button class="btn btn-blue btn-sm" *ngIf="(userState | async).user.permissions['auditor.limit'] > 0" (click)="changeProfileStatus(profile.id, 1)">
            Upgrade
          </button>
        </ng-container>
        <button *ngIf="profile.status === 2 && (userState | async).user.type === 1 && checkCertificateAvailability(profile.added_time)"
                class="btn btn-coral-light btn-sm"
                [routerLink]="['/audit/certificate', profile.id]">
          <i class="bi bi-award"></i>
        </button>
        <i class="bi bi-chevron-right row-chevron"></i>
      </div>
    </a>

    <!-- Load More -->
    <div class="load-more-section" *ngIf="(profileState | async).audits._embedded.items.length < (profileState | async).audits.total">
      <button (click)="loadData(limitPerPage + limit, page)" class="btn btn-default">
        <i class="bi bi-arrow-down-circle"></i>
        Load more reports
      </button>
    </div>

    <!-- Add New -->
    <div class="add-new-section">
      <a routerLink="/audit/add" class="btn btn-blue btn-animated">
        <i class="bi bi-plus-lg"></i>
        Add a new report
      </a>
      <p class="demo-hint">or check out our demo reports below</p>
    </div>
  </div>

  <!-- Demo Reports -->
  <div class="demo-reports-section">
    <app-demo-list></app-demo-list>
  </div>
</section>
